module.exports = __webpack_public_path__ + "img/hero-2-alternative-guide.dad7c4aa.png";